<template lang="pug">
.input-wrapper
  span.input-label.p-small {{ label }} {{ requiredSymbol }}
  .form-control-icon
    Icon.icon(
      v-if='!!icon',
      :name='icon',
      :style='"width: 1.25rem; height: 1.5rem; margin-top: 18px !important;" + `color: var(--color-${getColorIcon}); `'
    )
    v-select#select-input.pt-3.pb-2(
      :options='options',
      :class='["form-select", errorLog ? "invalid" : ""]',
      :placeholder='placeholder',
      :filter="(options: any, search: any) => filterWithoutAccents(options, search, labelSelectable)"
      :disabled='isDisabled',
      :label='labelSelectable',
      v-model='value',
      style='marign: 0'
    )
      template(v-slot:no-options) Nenhuma opção encontrada

  .invalid-feedback(v-if='!!errorLog')
    span.text {{ errorLog }}
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue'
  import Icon from '../../../../components/Atoms/Icon.vue'
  import { filterWithoutAccents } from '@/utils/search'

  interface IOptionsSelectable {
    label: string
    value: string
    id?: number
  }

  export default defineComponent({
    name: 'InputSelect',
    components: {
      Icon,
    },
    props: {
      label: {
        type: String,
        required: false,
      },
      icon: {
        type: String,
        required: false,
      },
      options: {
        type: Array as PropType<IOptionsSelectable[]>,
      },
      isDisabled: {
        type: Boolean,
      },
      isRequired: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
      },
      errorLog: {
        type: String,
        default: '',
      },
      modelValue: {
        type: Object,
      },
      labelSelectable: {
        type: String,
      },
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: any) {
          this.$emit('update:modelValue', value)
        },
      },
      requiredSymbol() {
        return this.$props.isRequired && this.$props.label ? '*' : ''
      },
      getColorIcon() {
        if (this.$props.isDisabled) {
          return 'gray-dark'
        }

        if (this.$props.errorLog !== '') {
          return 'danger'
        }

        return 'primary'
      },
    },
    watch: {
      options() {
        this.value = undefined
      },
    },
    methods: {
      filterWithoutAccents: filterWithoutAccents,
    },
  })
</script>

<style>
  #select-input {
    max-height: 30px;
  }

  .vs__dropdown-toggle {
    overflow: hidden;
  }

  .vs__dropdown-menu {
    padding: 0.5rem !important;
    margin-top: 16px !important;
    border-radius: 16px !important;
  }

  .vs__dropdown-option:hover,
  .vs__dropdown-option--highlight {
    background: #e6e7ec !important;
    border-radius: 16px !important;
    color: #2f3242 !important;
  }
</style>
